/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TourShotsPageQueryVariables = {
    tourID: string;
};
export type TourShotsPageQueryResponse = {
    readonly tour: {
        readonly id?: string;
        readonly title?: string;
        readonly thumbnailURL?: string;
        readonly " $fragmentRefs": FragmentRefs<"TourShotsGrid_tour">;
    } | null;
    readonly me: {
        readonly user: {
            readonly " $fragmentRefs": FragmentRefs<"TruvuToursContainer_user">;
        } | null;
    } | null;
};
export type TourShotsPageQuery = {
    readonly response: TourShotsPageQueryResponse;
    readonly variables: TourShotsPageQueryVariables;
};



/*
query TourShotsPageQuery(
  $tourID: ID!
) {
  tour: node(id: $tourID) {
    __typename
    ... on Tour {
      id
      title
      thumbnailURL
      ...TourShotsGrid_tour
    }
    id
  }
  me {
    user {
      ...TruvuToursContainer_user
      id
    }
  }
}

fragment TourShotsGrid_tour on Tour {
  id
  title
  status {
    status
    id
  }
  videoURL
  thumbnailURL
  shots {
    id
    shotType
    shotStatus
    roomType
    frameScore
    sourceClipIndex
    sourceFramePosition
    originalImageURI
    enhancedImageURI
    stagedImageURI
    createdAt
    errorMessage
  }
}

fragment TruvuToursContainer_user on User {
  profile {
    name
    surname
    profileImageURL
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tourID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "tourID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailURL",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourShotsPageQuery",
    "selections": [
      {
        "alias": "tour",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TourShotsGrid_tour"
              }
            ],
            "type": "Tour",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TruvuToursContainer_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourShotsPageQuery",
    "selections": [
      {
        "alias": "tour",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TourProgress",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shot",
                "kind": "LinkedField",
                "name": "shots",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shotType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shotStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roomType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frameScore",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceClipIndex",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceFramePosition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "originalImageURI",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enhancedImageURI",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stagedImageURI",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "errorMessage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Tour",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "surname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileImageURL",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "13a9b25690212e3de0b923ba05f928b5",
    "id": null,
    "metadata": {},
    "name": "TourShotsPageQuery",
    "operationKind": "query",
    "text": "query TourShotsPageQuery(\n  $tourID: ID!\n) {\n  tour: node(id: $tourID) {\n    __typename\n    ... on Tour {\n      id\n      title\n      thumbnailURL\n      ...TourShotsGrid_tour\n    }\n    id\n  }\n  me {\n    user {\n      ...TruvuToursContainer_user\n      id\n    }\n  }\n}\n\nfragment TourShotsGrid_tour on Tour {\n  id\n  title\n  status {\n    status\n    id\n  }\n  videoURL\n  thumbnailURL\n  shots {\n    id\n    shotType\n    shotStatus\n    roomType\n    frameScore\n    sourceClipIndex\n    sourceFramePosition\n    originalImageURI\n    enhancedImageURI\n    stagedImageURI\n    createdAt\n    errorMessage\n  }\n}\n\nfragment TruvuToursContainer_user on User {\n  profile {\n    name\n    surname\n    profileImageURL\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bb2e16046a6a31618ab3fc0bf3e64179';
export default node;
